import type { PayResponse } from 'services/api/pay';

export function existingOrderInfo(order: Pay.Order, res: PayResponse, accid: string) {
  const {
    orderCode,
    orderDescribe: { accountNum, durationNum, validStartStr, validEndStr },
    amount,
    orderAction,
    packageId,
    regionPackageId,
    trafficPackageType,
    handleNum,
    orderNumber,
  } = order;

  return {
    accid,
    accountNum,
    durationNum,
    orderCode,
    discountTotalPrice: `${amount}`,
    orderAction,
    ...res,
    currency: res.currency || order.currency,
    payType: res.payType || 'alipay',
    packageId,
    regionPackageId: regionPackageId ?? undefined,
    trafficPackageType,
    validStartStr,
    validEndStr,
    handleNum,
    orderNumber,
  };
}
